import React, { createContext, useMemo, useState } from 'react';

export const DriveContext = createContext(null);

export const DriveProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [folderName, setFolderName] = useState('');
  const [applicationId, setApplicationId] = useState('');

  const [currentFolder, setCurrentFolder] = useState('root');
  const [breadcrumbs, setBreadcrumbs] = useState([{ id: 'root', name: 'Home' }]);

  const [view, setView] = useState('table');
  const [search, setSearch] = useState('');

  const [uploads, setUploads] = useState([]);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  const value = useMemo(
    () => ({
      items,
      setItems,

      folderName,
      setFolderName,

      applicationId,
      setApplicationId,

      currentFolder,
      setCurrentFolder,

      breadcrumbs,
      setBreadcrumbs,

      view,
      setView,

      search,
      setSearch,

      uploads,
      setUploads,

      previewOpen,
      setPreviewOpen,

      previewFile,
      setPreviewFile,
    }),
    [
      items,
      folderName,
      applicationId,
      currentFolder,
      breadcrumbs,
      view,
      search,
      uploads,
      previewOpen,
      previewFile,
    ]
  );

  return <DriveContext.Provider value={value}>{children}</DriveContext.Provider>;
};
